const CALENDLY_URL = "https://calendly.com/summercrestai";

const SCRIPT_ID = "calendly-widget-script";
const SCRIPT_SRC = "https://assets.calendly.com/assets/external/widget.js";

let scriptPromise;

export function loadCalendly() {
    if (window.Calendly?.initPopupWidget) {
        return Promise.resolve(window.Calendly);
    }
    if (scriptPromise) return scriptPromise;

    scriptPromise = new Promise((resolve, reject) => {
        const existing = document.getElementById(SCRIPT_ID);
        if (existing) {
            existing.addEventListener("load", () => resolve(window.Calendly));
            existing.addEventListener("error", () => reject(new Error("Calendly widget script was blocked")));
            return;
        }
        const script = document.createElement("script");
        script.id = SCRIPT_ID;
        script.src = SCRIPT_SRC;
        script.async = true;
        script.onload = () => {
            if (window.Calendly?.initPopupWidget) {
                resolve(window.Calendly);
            } else {
                reject(new Error("Calendly loaded without its popup API"));
            }
        };
        script.onerror = () => reject(new Error("Calendly widget script was blocked"));
        document.head.appendChild(script);
    });
    return scriptPromise;
}

export function openCalendlyFallback() {
    const newTab = window.open(CALENDLY_URL, "_blank", "noopener,noreferrer");
    if (!newTab) {
        const link = document.createElement("a");
        link.href = CALENDLY_URL;
        link.target = "_blank";
        link.rel = "noopener noreferrer";
        link.click();
    }
}

export async function openCalendlyPopup() {
    try {
        const calendly = await loadCalendly();
        calendly.initPopupWidget({ url: CALENDLY_URL });
        return true;
    } catch (error) {
        openCalendlyFallback();
        return false;
    }
}

export { CALENDLY_URL };
